import { createStructuredSelector } from 'reselect';
import {
    TASK_EMPLOYEE_LIST,
    TASK_EMPLOYEE_LIST_SUCCESS,
    TASK_EMPLOYEE_LIST_ERROR,
    TASK_EMPLOYEE_ADD,
    TASK_EMPLOYEE_ADD_SUCCESS,
    TASK_EMPLOYEE_ADD_ERROR,
    TASK_EMPLOYEE_UPDATE,
    TASK_EMPLOYEE_UPDATE_SUCCESS,
    TASK_EMPLOYEE_UPDATE_ERROR,
    TASK_EMPLOYEE_MODAL_SET,
    TASK_EMPLOYEE_SELECTED_SET
} from '../actions';

export const TaskEmployeeList = (data) => ({
    type: TASK_EMPLOYEE_LIST,
    payload: data
});

export const TaskEmployeeListSuccess = (data) => ({
    type: TASK_EMPLOYEE_LIST_SUCCESS,
    payload: data
});

export const TaskEmployeeListError = (error) => ({
    type: TASK_EMPLOYEE_LIST_ERROR,
    payload: error
});

export const TaskEmployeeAdd = (data) => ({
    type: TASK_EMPLOYEE_ADD,
    payload: data
});

export const TaskEmployeeAddSuccess = (data) => ({
    type: TASK_EMPLOYEE_ADD_SUCCESS,
    payload: data
});

export const TaskEmployeeAddError = (error) => ({
    type: TASK_EMPLOYEE_ADD_ERROR,
    payload: error
});

export const TaskEmployeeUpdate = (data) => ({
    type: TASK_EMPLOYEE_UPDATE,
    payload: data
});

export const TaskEmployeeUpdateSuccess = (data) => ({
    type: TASK_EMPLOYEE_UPDATE_SUCCESS,
    payload: data
});

export const TaskEmployeeUpdateError = (error) => ({
    type: TASK_EMPLOYEE_UPDATE_ERROR,
    payload: error
});

export const TaskEmployeeModalSet = (data) => ({
    type: TASK_EMPLOYEE_MODAL_SET,
    payload: data
});

export const TaskEmployeeSelectedSet = (data) => ({
    type: TASK_EMPLOYEE_SELECTED_SET,
    payload: data
});

const task_employee = (state) => state.task_employee;

export const TaskEmployeeSelector = createStructuredSelector({ task_employee });
